import React from 'react';
import { BasicToolbarMenuItem } from '../../application-controls';
import { connect } from 'redux-bundler-react';
import addGeoJSON from './add-data-geojson-worker';
import AddDataTooLarge from './add-data-too-large';
import FileSizeString from '../../utils/fileSizeString';

class AddShapefileButton extends React.Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleAccept = this.handleAccept.bind(this);
  }
  handleCancel() {
    const {doCloseModalWindow} = this.props;
    this.geojsonInput.files = null;
    doCloseModalWindow();
  }
  handleAccept() {
    const {doCloseModalWindow, onError, doAddDataGeojson, doSetCursor} = this.props;
    const file = this.geojsonInput.files[0];
    doCloseModalWindow();
    doSetCursor('wait')
    addGeoJSON.fromShp(file, (geojsonResult) => {
      if(geojsonResult.data.type === 'error') {
        onError(`${file.name} had an error when parsing`);
        doSetCursor();
      } else if(geojsonResult.data.type === 'geojson') {
        doAddDataGeojson(file.name, geojsonResult.data.geojson);
      }
    });
    this.geojsonInput.files = null; 
  }
  handleClick(e) {
    this.geojsonInput.click();
  }
  openModal(fileSize){
    const { doOpenModalWindow} = this.props;
    doOpenModalWindow({
      children: [AddDataTooLarge],
      options: {fileSize:fileSize, handleAccept:this.handleAccept, handleCancel: this.handleCancel},
      openedBy: 'add-data-button'
    })
  }
  handleFile(e){
    const { onError, doAddDataGeojson, doSetCursor} = this.props;
    if(this.geojsonInput.files[0]) {
      const file = this.geojsonInput.files[0];
      const fileSize = this.geojsonInput.files[0].size;
      if(file && file.name.match(/\.zip$/)){
        if(fileSize> (20*1048576) ) {
          const fileSizeStr = FileSizeString(fileSize);
          this.openModal(fileSizeStr);
        }else{
          doSetCursor('wait')
          addGeoJSON.fromShp(file, (geojsonResult) => {
            if(geojsonResult.data.type === 'error') {
              onError(`${file.name} had an error when parsing`);
              doSetCursor();
            } else if(geojsonResult.data.type === 'geojson') {
              doAddDataGeojson(file.name, geojsonResult.data.geojson);
            }
          }); 
        } 
      }else{
        if(file) onError(`${file.name} is not a supported Zip file type`);
      }
    }
    
    this.geojsonInput.files = null;
  }

  render(){
    return (
      <BasicToolbarMenuItem
        active={ false }
        iconClass="ms ms-geojson icon-inline"
        title="Add Local Shapefile in Zip"
        text="Add Local Shapefile in Zip"
        onClick={ this.handleClick }
        passProps={{}}
        disableSubmenu={true}
      >
        <input onChange={ this.handleFile } accept={'application/zip'}  className="hidden" type="file" ref={(el) => { this.geojsonInput = el}} /> 
      </BasicToolbarMenuItem>
    )
  }
}

export default connect(
  'doSetCursor',
  'doAddDataGeojson',
  'doOpenModalWindow',
  'doCloseModalWindow',
  AddShapefileButton
);